import { createContext, useContext } from "react";
import useCourseData from "@hooks/useCourseData";

export const CourseContext = createContext();

export const CourseProvider = ({
  search_text = null,
  include_topics = null,
  is_public = true,
  department_id = null,
  level = null,
  children 
}) => {
  
  const {
    courses,
    loading,
    error,
    courseCount,
    fetchCourses,
    fetchNextPage,
    fetchPreviousPage,
    addCourse,
    editCourse,
    removeCourse,
    hasNext,
    hasPrevious,
    page,
  } = useCourseData({ search_text, include_topics, is_public, department_id, level });

  return (
    <CourseContext.Provider
      value={{
        courses,
        loading,
        error,
        courseCount,
        fetchCourses,
        fetchNextPage,
        fetchPreviousPage,
        addCourse,
        editCourse,
        removeCourse,
        hasNext,
        hasPrevious,
        page,
      }}
    >
      {children}
    </CourseContext.Provider>
  );
};

export const useCourses = () => useContext(CourseContext);
